<h1 multilang mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
    <p>{{data.message}}</p>
</div>
<div mat-dialog-actions>
    <div style="display: flex;width: 100%;justify-content: flex-end;">
        <button mat-button (click)="onNoClick()">Abrechen</button>
        <button mat-flat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>Ja</button>
    </div>
</div>